const STALE_KEYS = {
  recordBooks: [
    "installationObj",
    "environmentalConditionObj",
    "speedObj",
    "phaseObj",
    "measurementFormObj",
    "nozzleDiameterObj",
    "humidityObj",
    "manualObj",
    "isBuilt",
  ],
  configurationLines: [
    "parameterObject",
    "installationObject",
    "vle",
    "isBuilt",
  ],
  samples: [
    "mainParametersObjects",
    "secondParameterObject",
    "phaseObject",
    "mainParametersList",
    "mainParametersObjectsList",
    "previousSampleObject",
    "nextSampleObject",
    "isBuilt",
  ],
  sampleFlasks: [
    "sampleObjects",
    "installationObject",
    "orderForm",
    "priority",
    "isBuilt",
  ],
  analysisResult: ["sampleFlaskObj", "isBuilt"],
};

const dropStaleKeys = (tx) =>
  Promise.all(
    Object.entries(STALE_KEYS).map(([table, keys]) =>
      tx
        .table(table)
        .toCollection()
        .modify((row) => {
          const staleKeys = keys.filter((key) => key in row);
          staleKeys.forEach((key) => delete row[key]);
          return staleKeys.length > 0;
        })
    )
  );

// G.R 15/10/26 ne jamais retirer une entrée : un poste resté sur une VERSION
// antérieure rejoue à l'ouverture toutes celles qui la dépassent.
export default {
  87: dropStaleKeys,
};
